/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/22/18
 * Copyright All Rights Reserved
 */
// @flow
import classNames from 'classnames';
import * as React from 'react';
import { page } from './Page.module.scss';

type Props = {
  children?: React.Node,
  className?: string,
}

const Page = ({ children, className }: Props) => (
  <div className={classNames(className, page)}>
    {children}
  </div>
);

Page.defaultProps = {
  children: null,
  className: '',
};

export default Page;



// WEBPACK FOOTER //
// ./js/components/support/layout/Page/index.jsx